import useFetchSelect from 'elements/Hooks/useFetchSelect'
import withMapList from '../../../elements/HOC/withMapList'
import withSort from '../../../elements/HOC/withSort'
import withSpinning from '../../../elements/HOC/withSpinning'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import CustomTable from '../../../elements/Table/CustomTable'
import { defaultFormItemLayout } from '../../../modules/FormItems'
import { dateVal, strVal } from '../../../modules/Utils'
import React, { useEffect } from 'react'
import { Col, DatePicker, Form, Input, Row } from 'antd'
import { get, isEmpty } from 'lodash'
import { compose } from 'recompose'

const { TextArea } = Input

const EmployeesSelect = compose(
  withUrlFetch({
    name: 'employees',
    url: 'employees?status=Active',
    cache: true,
  }),
  withSpinning,
  withSort
)(CustomSelect)

function TimesheetForm(props) {
  const { timesheet, onChangeContract, contractData, onChangeOrder, orderDate, rates, fetchingRates } = props

  const { getFieldDecorator, getFieldValue } = props.form

  let employee = getFieldValue('employee._id') || get(timesheet, 'employee._id', '')

  let contract = getFieldValue('contract._id') || get(timesheet, 'contract._id', '')

  let order = getFieldValue('order._id') || get(timesheet, 'order._id', '')

  const { SelectData: ContractsSelect } = useFetchSelect({
    url: `employees/${employee.replace('partners', '')}/contracts?status=Approved`,
    dependencyArray: [employee],
    dontFetch: isEmpty(employee),
    mapFunction: (c) => ({
      ...c,
      name: `${c.name} - ${strVal(c, 'title')}`,
    }),
  })

  const { SelectData: OrderSelect } = useFetchSelect({
    url: `labours/${contract.replace('labourContracts/', '')}/list?select=*`,
    dependencyArray: [contract],
    dontFetch: isEmpty(contract),
  })

  useEffect(() => {
    contract && onChangeContract(contract)
    order && onChangeOrder(order)
  }, [contract, order])

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Employee">
            {getFieldDecorator('employee._id', {
              initialValue: get(timesheet, 'employee._id'),
            })(
              <EmployeesSelect
                placeholder={'Select an Employee'}
                keyAtr={'p_id'}
                valueAtr={'name'}
                style={{ width: '100%' }}
              />
            )}
          </Form.Item>
        </Col>
        {employee && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Contract">
              {getFieldDecorator('contract._id', {
                initialValue: get(timesheet, 'contract._id'),
              })(<ContractsSelect keyAtr={'_id'} valueAtr={'code'} placeholder={'Contracts Account'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        {contract && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Order">
              {getFieldDecorator('order._id', {
                initialValue: get(timesheet, 'order._id'),
              })(
                <OrderSelect
                  placeholder={'Select an Employee'}
                  keyAtr={'_id'}
                  valueAtr={'code'}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Start Date">
            {getFieldDecorator('start', {
              initialValue: dateVal(timesheet, 'start'),
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="End Date">
            {getFieldDecorator('end', {
              initialValue: dateVal(timesheet, 'end'),
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
      </Row>
      {/*<Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Office Hours">
            {getFieldDecorator('officeHours', {
              initialValue: numVal(timesheet, 'officeHours'),
            })(<InputNumber style={{width: '100%'}} />)}
          </Form.Item>
        </Col>
      </Row>*/}
      {rates.length !== 0 && (
        <Row>
          <CustomTable
            data={rates}
            fetching={fetchingRates}
            columns={[
              { Header: 'Name', accessor: 'name' },
              { Header: 'Rate', accessor: 'rate' },
              { Header: 'Type', accessor: 'type' },
              { Header: 'UOM', accessor: 'uom' },
            ]}
          />
        </Row>
      )}
    </Form>
  )
}

TimesheetForm.propTypes = {}
TimesheetForm.defaultProps = {}

export default Form.create()(TimesheetForm)
